import _ from 'lodash';
import React, { Component } from 'react';

import AnimateHeight from 'react-animate-height';
import { browserHistory, Link } from 'react-router';
import classnames from 'classnames';
import { connect } from 'react-redux';
import { CSSTransitionGroup } from 'react-transition-group';

import { fetchBookings, fetchBookingHistory } from 'actions/bookingActions';
import { openModal } from 'actions/modalActions';
import { getTrialCoupon } from 'actions/userActions';

import AlertDanger from 'components/alerts/AlertDanger/AlertDanger';
import BookingList from 'components/BookingList/BookingList';
import BookingSuccessAlert from 'components/BookingSuccessAlert';
import Loading from 'components/Loading/Loading';
import StudentReservationHistory from 'components/StudentReservationHistory';

import './style.css';

const RESERVATIONS_MODE = {
  UPCOMING: 'upcoming',
  ALL: 'all',
};

class Reservations extends Component {
  constructor(props) {
    super(props);
    this.state = {
      mode:
        props.location.query.view === 'all' ?
          RESERVATIONS_MODE.ALL :
          RESERVATIONS_MODE.UPCOMING,
      currentPage: 0,
      showBookingSuccess: props.location.query.showSuccess === 'true',
    };
  }

  // when the user returns to the Reservations from
  // another page, reload the booking data
  componentWillMount() {
    if (this.props.user && this.props.user.id) {
      this.loadBookings(this.state.mode);
    }
  }

  // during first login, we need to wait for the customer response
  // before calling fetchBookings, so we will watch for the
  // customer id to update, and then fetch the booking data
  componentWillReceiveProps(nextProps) {
    // do nothing if the new props doesn't have a customer.id
    // or if the id is unchanged from the previous props
    if (nextProps.user.id && nextProps.user.id !== this.props.user.id) {
      this.loadBookings(this.state.mode);
    }
  }

  closeNotification = (event) => {
    event.preventDefault();
    this.setState({ showBookingSuccess: false });
  };

  handleClickReservationsMode = (mode) => {
    return (event) => {
      event.preventDefault();
      if (mode !== this.state.mode) {
        this.setState({ mode });
        const query = mode === RESERVATIONS_MODE.ALL ? '?view=all' : '';
        browserHistory.push(this.props.location.pathname + query);
        this.loadBookings(mode);
      }
    };
  };

  loadBookings = (mode, page) => {
    if (mode === RESERVATIONS_MODE.ALL) {
      this.props.fetchBookingHistory(page);
    } else {
      this.props.fetchBookings(page);
    }
  };

  handlePaginationClick = (data) => {
    const { selected: page } = data;
    this.setState({ currentPage: page });
    this.loadBookings(RESERVATIONS_MODE.ALL, page);
  };

  offerTrialUpgrade() {
    const { trialStatus } = this.props.user;
    if (trialStatus && trialStatus.status === 'credit_trial') {
      this.props.getTrialCoupon((coupon) => {
        setTimeout(() => {
          this.props.openModal('trial-upgrade-modal', { coupon });
        }, 1500);
      });
    }
  }

  handleRateClick = (appointment) => {
    this.props.openModal('confirm-lesson-modal', {
      appointment,
      skipDisabled: true,
      onRatingComplete: () => {
        if (this.state.mode === RESERVATIONS_MODE.ALL) {
          this.props.fetchBookingHistory(this.state.currentPage);
        }
        this.offerTrialUpgrade();
      },
    });
  };

  onRefer = () => {
    this.setState({ showBookingSuccess: false });
  };

  renderLoading() {
    return (
      <div className="Reservations">
        <Loading />
      </div>
    );
  }

  renderError(error) {
    return (
      <AlertDanger
        className="Reservations ReservationsError mt-4"
        error={error}
      />
    );
  }

  renderScheduleNewLesson() {
    return (
      <div className="ScheduleNewLesson text-center">
        <Link className="ScheduleLink" to="/schedule-lesson">
          <div className="card">
            <div className="card-block d-flex flex-column p-5">
              <i className="fa fa-plus fa-2x mb-2" />

              <span className="strong mt-2">Schedule Lesson</span>
            </div>
          </div>
        </Link>
      </div>
    );
  }

  renderNavigation(numberOfBookings, isLoading) {
    const { mode } = this.state;

    const bookingsType = mode === RESERVATIONS_MODE.ALL ? 'total' : 'upcoming';
    const reservationsCountText = isLoading ?
      '...' :
      `${numberOfBookings} ${bookingsType} lesson${
        numberOfBookings === 1 ? '' : 's'
      }`;
    return (
      <div className="header-block">
        <div className="mb-4">
          <h2 className="mb-0">Reservations</h2>
          <div className="upcoming-lessons">
            <p className="mb-1 mt-1">{reservationsCountText}</p>
          </div>
        </div>

        <div className="row">
          <div className="col-12 col-lg-8">
            <Link to="/schedule-lesson">
              <button
                type="button"
                className="btn btn-secondary btn-cursor schedule-button"
              >
                Schedule +
              </button>
            </Link>
          </div>
          <div className="col-12 col-lg-4">
            <div className="d-flex align-items-center justify-content-start justify-content-lg-end">
              <div
                className="btn-group"
                role="group"
                aria-label="calendar-mode"
              >
                <button
                  type="button"
                  className={classnames(
                    'Reservations__mode btn btn-secondary btn-cursor upcoming-button',
                    {
                      selected: mode === RESERVATIONS_MODE.UPCOMING,
                    }
                  )}
                  onClick={this.handleClickReservationsMode(
                    RESERVATIONS_MODE.UPCOMING
                  )}
                >
                  Upcoming
                </button>
                <button
                  type="button"
                  className={classnames(
                    'Reservations__mode btn btn-secondary btn-cursor all-button',
                    {
                      selected: mode === RESERVATIONS_MODE.ALL,
                    }
                  )}
                  onClick={this.handleClickReservationsMode(
                    RESERVATIONS_MODE.ALL
                  )}
                >
                  All
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }

  render() {
    const { futureBookings } = this.props;
    const { mode } = this.state;

    // Error state
    if (futureBookings.error) {
      return this.renderError(futureBookings.error);
    }

    // Loading state
    let isLoading = false;
    if (mode === RESERVATIONS_MODE.ALL) {
      isLoading =
        futureBookings.periodBookingsStatus === null ||
        futureBookings.periodBookingsStatus === 'LOADING';
    } else {
      isLoading =
        futureBookings.status === null || futureBookings.status === 'LOADING';
    }

    const { totalBookings } = futureBookings;
    const bookings =
      mode === RESERVATIONS_MODE.ALL ?
        futureBookings.periodBookings :
        futureBookings.bookings;
    const numBookings =
      mode === RESERVATIONS_MODE.ALL ? totalBookings || 0 : _.size(bookings);

    return (
      <div className="Reservations">
        <CSSTransitionGroup
          transitionName="alertFades"
          transitionAppear
          transitionEnter={false}
          transitionLeave={false}
          transitionAppearTimeout={500}
        >
          <AnimateHeight
            duration={250}
            height={this.state.showBookingSuccess ? 'auto' : 0}
          >
            <BookingSuccessAlert
              onClose={this.closeNotification}
              onRefer={this.onRefer}
            />
          </AnimateHeight>
        </CSSTransitionGroup>
        {this.renderNavigation(numBookings, isLoading)}

        <section>
          <div className="row">
            <div className="content-wrapper col-12">
              {isLoading && this.renderLoading()}

              {!isLoading && _.isEmpty(bookings) && (
                <div className="BookingList">
                  {this.renderScheduleNewLesson()}
                </div>
              )}

              {!isLoading &&
                !_.isEmpty(bookings) &&
                mode === RESERVATIONS_MODE.UPCOMING && (
                  <CSSTransitionGroup
                    transitionName="bookingsFades"
                    transitionAppear
                    transitionEnter={false}
                    transitionLeave
                    transitionAppearTimeout={300}
                    transitionLeaveTimeout={500}
                  >
                    <BookingList bookings={bookings || []} />
                  </CSSTransitionGroup>
              )}

              {!isLoading &&
                !_.isEmpty(bookings) &&
                mode === RESERVATIONS_MODE.ALL && (
                  <CSSTransitionGroup
                    transitionName="bookingsFades"
                    transitionAppear
                    transitionEnter={false}
                    transitionLeave
                    transitionAppearTimeout={300}
                    transitionLeaveTimeout={500}
                  >
                    <div className="card history-wrapper">
                      <StudentReservationHistory
                        reservations={bookings || []}
                        total={totalBookings}
                        pageSize={this.props.pageSize}
                        page={this.state.currentPage}
                        handlePaginationClick={this.handlePaginationClick}
                        handleRateClick={this.handleRateClick}
                      />
                    </div>
                  </CSSTransitionGroup>
              )}
            </div>
          </div>
        </section>
      </div>
    );
  }
}

function mapStateToProps(state) {
  return {
    user: state.user.profile,
    futureBookings: state.bookings,
    pageSize: state.bookings.pageSize,
  };
}

export default connect(mapStateToProps, {
  fetchBookings,
  fetchBookingHistory,
  openModal,
  getTrialCoupon,
})(Reservations);



// WEBPACK FOOTER //
// ./src/pages/student/Reservations/index.js